import React from 'react';

import { ShadedBox, ShadedBoxTitle } from '../BasePage';
import { IUEvent } from '../../lib/event';

import PhotosLink from './PhotosLink';
import styled from 'styled-components';
import { DEFAULT_COLORS } from '../../contexts/BackgroundContext';
import { DeviceQueries } from 'Common/src/components/styled';
import { MobileShow, DesktopShow } from '../../components/styled/Common';

const maxPhotosDisplayedDesktop = 16;
const maxPhotosDisplayedMobile = 2;

const AlbumDetails = ({ event, setShowPhotoViewer }: {
  event: IUEvent,
  setShowPhotoViewer: React.Dispatch<React.SetStateAction<boolean>>
}) => {
  const albumDetails = event.albumDetails;

  if (albumDetails === undefined) {
    return null;
  }

  return <>
    <PhotosLink event={event}/>

    {albumDetails.photoMetas !== undefined && albumDetails.photoMetas.length > 0 &&
      <>
        <PreviewContainer onClick={() => setShowPhotoViewer(true)}>
          {
            albumDetails.photoMetas.map((photoMeta) => {
              return <ImageContainer key={photoMeta.photoId}>
                <PreviewImage src={photoMeta.thumbnailUrl}/>
              </ImageContainer>
            })}
        </PreviewContainer>
        <DesktopShow>
          {albumDetails.photoMetas.length > maxPhotosDisplayedDesktop &&
            <SeePhotosText onClick={() => setShowPhotoViewer(true)}>
              See all photos
            </SeePhotosText>
          }
        </DesktopShow>
        <MobileShow>
          {albumDetails.photoMetas.length > maxPhotosDisplayedMobile &&
            <SeePhotosText onClick={() => setShowPhotoViewer(true)}>
              See all photos
            </SeePhotosText>
          }
        </MobileShow>
      </>}
  </>;
};

const PreviewContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 10px;

  @media (${DeviceQueries.mobile}) {
    justify-content: center;
  }
`

const ImageContainer = styled.div`
  width: 110px;
  height: 110px;
  margin: 5px;

  @media (${DeviceQueries.mobile}) {
    // Hide 3rd and later images on mobile
    &:nth-child(n + 3) {
      display: none;
    }
  }

  @media not (${DeviceQueries.mobile}) {
    // Hide 17th and later images on desktop
    &:nth-child(n + 17) {
      display: none;
    }
  }
`

const PreviewImage = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
  cursor: pointer;
`;

const SeePhotosText = styled.div`
  width: 100%;
  text-align: right;
  margin: 15px 0 2px 0;
  font-size: 14px;
  cursor: pointer;
  color: ${DEFAULT_COLORS.highlightText};
`

export default AlbumDetails;
